document.addEventListener('DOMContentLoaded', function() {
  
  // Check if URL contains the affiliate parameter
  function checkAffiliateParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const programId = urlParams.get('program');
        
    if (programId === '261778') {
      showAffiliateModal();
    } 
  }
  
  // Show the modal
  function showAffiliateModal() {
    const modal = document.getElementById('affiliateModal');
    if (modal) {
      modal.classList.add('show');
    } 
  }
  
  // Close modal function (global scope for onclick)
  window.closeAffiliateModal = function() {
    const modal = document.getElementById('affiliateModal');
    if (modal) {
      modal.classList.remove('show');
    }
  };
  
  // Close modal when clicking outside
  document.addEventListener('click', function(e) {
    const modal = document.getElementById('affiliateModal');
    if (modal && e.target === modal) {
      closeAffiliateModal();
    }
  });
  
  // Close modal with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAffiliateModal();
    }
  });
  
  // Check for affiliate parameter on page load
  checkAffiliateParameter();
}); 